import { type ReactNode } from "react";

interface MyHeaderLabelProps {
  label: string;
  style?: string;
  border?: boolean;
  line?: boolean;
  shadow?: boolean;
  borderColor?: string;
  icon?: ReactNode;
  badge?: string | number;
}

const MyHeaderLabel = ({
  label,
  style = "text-gray-900 dark:text-gray-100 text-lg lg:text-2xl",
  border= false,
  line= false,
  shadow= false,
  borderColor = "border-gray-300 dark:border-gray-700",
  icon,
  badge,
}: MyHeaderLabelProps) => {


  return (
    <div className="flex items-center justify-center gap-2 w-full">

      {/* Left Line */}
      <span className={`flex-1 ${line && "border-b-2"} ${borderColor}`}></span>

      {/* Center Box */}
      <div className={`
        flex items-center gap-2
        ${border &&"border-2"} border-gray-300 dark:border-gray-700
        bg-white dark:bg-gray-800 
        rounded-full px-5 py-1 ${shadow &&"shadow-sm"}
      `}>
        {icon && <span className="text-xl text-gray-700 dark:text-gray-200">{icon}</span>}

        <h2 className={`font-extrabold tracking-tight ${style}`}>
          {label}
        </h2>

        {badge && (
          <span className="ml-2 bg-red-600 dark:bg-red-500 text-white text-sm font-semibold px-2 py-0.5 rounded-full">
            {badge}
          </span>
        )}
      </div>

      {/* Right Line */}
      <span className={`flex-1 ${line &&"border-b-2"} ${borderColor}`}></span>
    </div>
  );
};

export default MyHeaderLabel;